import React from "react";
import { Link } from "react-router-dom";
import { Dices, Mail, MapPin, Phone, Heart } from "lucide-react";
import { useLang } from "../i18n";

const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-white mt-20 border-t-4 border-slate-900">
      <div className="bg-yellow-300 border-b-4 border-slate-900 py-4 overflow-hidden">
        <div className="flex gap-12 text-slate-900 font-bold text-lg animate-pulse whitespace-nowrap justify-center font-display tracking-wide">
          <span>SPEDIZIONE GRATIS DA 49€</span>
          <span className="hidden sm:inline">★</span>
          <span className="hidden sm:inline">RESO FACILE 14 GIORNI</span>
          <span className="hidden md:inline">★</span>
          <span className="hidden md:inline">PAGAMENTI SICURI PAYPAL</span>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-10 h-10 bg-pink-400 border-4 border-white rounded-full flex items-center justify-center">
              <Dices className="w-5 h-5 text-slate-900" strokeWidth={2.5} />
            </span>
            <span className="font-display font-bold text-2xl">
              Bottega <span className="text-yellow-300">di Nalise</span>
            </span>
          </div>
          <p className="text-slate-300 max-w-md leading-relaxed">
            {t("footer.about_text")}
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold text-lg mb-4 text-yellow-300">{t("footer.links_title")}</h4>
          <ul className="space-y-2 text-slate-300">
            <li><Link to="/" className="hover:text-pink-300 transition-colors">{t("nav.home")}</Link></li>
            <li><Link to="/catalog" className="hover:text-pink-300 transition-colors">{t("nav.catalog")}</Link></li>
            <li><Link to="/regalo-perfetto" className="hover:text-pink-300 transition-colors">🎁 {t("nav.gift")}</Link></li>
            <li><Link to="/chi-siamo" className="hover:text-pink-300 transition-colors">{t("nav.about")}</Link></li>
            <li><Link to="/wishlist" className="hover:text-pink-300 transition-colors">{t("nav.wishlist")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-lg mb-4 text-yellow-300">{t("footer.contact_title")}</h4>
          <ul className="space-y-2 text-slate-300 text-sm">
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-pink-300 shrink-0" />
              <a href="mailto:info@nalise.it" className="hover:text-pink-300 transition-colors">info@nalise.it</a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-pink-300 shrink-0" />
              <a href="tel:+393924735682" className="hover:text-pink-300 transition-colors">+39 392 4735682</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 text-pink-300 shrink-0 mt-0.5" />
              <span>Via Sabotino 32<br />21049 Tradate (VA) — Italy</span>
            </li>
          </ul>
          <p className="mt-4 text-xs text-slate-500">P.IVA 03399260128</p>
        </div>
      </div>
      <div className="border-t border-slate-700 pt-6 pb-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-slate-300">
          <Link to="/termini-e-condizioni" data-testid="footer-terms" className="hover:text-pink-300 transition-colors">Termini e Condizioni</Link>
          <span className="text-slate-600">·</span>
          <Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-pink-300 transition-colors">Privacy Policy</Link>
          <span className="text-slate-600">·</span>
          <Link to="/cookie-policy" data-testid="footer-cookies" className="hover:text-pink-300 transition-colors">Cookie Policy</Link>
          <span className="text-slate-600">·</span>
          <Link to="/spedizioni-e-resi" data-testid="footer-shipping" className="hover:text-pink-300 transition-colors">Spedizioni e Resi</Link>
        </div>
      </div>
      <div className="py-5 text-center text-sm text-slate-400">
        © {new Date().getFullYear()} Bottega di Nalise — P.IVA 03399260128. {t("footer.rights")}.
        <span className="ml-2 inline-flex items-center gap-1">Made with <Heart className="w-3.5 h-3.5 text-pink-400" fill="#f9a8d4" /> by OBI</span>
      </div>
    </footer>
  );
};

export default Footer;
